import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-uganda-home-loan-affordability.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorUgandaHomeLoanAffordability = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorUgandaHomeLoanAffordability, _super);
    function CalculatorUgandaHomeLoanAffordability(element) {
        return _super.call(this, element) || this;
    }
    CalculatorUgandaHomeLoanAffordability.prototype.init = function () {
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputNetIncome = this.element.querySelector('input[name=net_income]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.totalLoanAmount = this.element.querySelector('.js-total-loan-amount');
        this.totalLoanTerm = this.element.querySelector('.js-total-loan-term');
        this.totalInterestRate = this.element.querySelector('.js-total-interest-rate');
        this.totalMonthlyPayment = this.element.querySelector('.js-total-monthly-payment');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-uganda-home-loan-affordability__result--terms');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        // this.calculate();
        TooltipsService.initTooltips();
    };
    CalculatorUgandaHomeLoanAffordability.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            _this.totalLoanAmount.innerHTML = "-";
            _this.totalLoanTerm.innerHTML = "-";
            _this.totalInterestRate.innerHTML = "-";
            _this.totalMonthlyPayment.innerHTML = "-";
        });
    };
    CalculatorUgandaHomeLoanAffordability.prototype.calculate = function () {
        var netIncome = parseFloat(this.inputNetIncome.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var term = parseFloat(this.inputTerm.value);
        var monthlyPayment = netIncome / 2;
        var pv = this.PV(interestRate / 1200, term, monthlyPayment, 0, 1) * -1;
        this.totalLoanAmount.innerHTML = this.formatter(this.round(pv, 0));
        this.totalLoanTerm.innerHTML = term + " Months";
        ;
        this.totalInterestRate.innerHTML = interestRate + "%";
        this.totalMonthlyPayment.innerHTML = this.formatter(this.round(monthlyPayment, 0));
        // let final: number = -this.PMT(interestRate / 1200, term, netIncome, 0, 0);
        // let finalString: any = this.formatter(this.round(final, 0));
    };
    CalculatorUgandaHomeLoanAffordability.prototype.PV = function (rate, nper, pmt, fv, type) {
        var pv_value = 0;
        rate = parseFloat(rate);
        nper = parseFloat(nper);
        pmt = parseFloat(pmt);
        fv = parseFloat(fv);
        if (nper == 0) {
            alert("Why do you want to test me with zeros?");
            return (0);
        }
        if (rate == 0) { // Interest rate is 0
            pv_value = -(fv + (pmt * nper));
        }
        else {
            var x = Math.pow(1 + rate, -nper);
            var y = Math.pow(1 + rate, nper);
            pv_value = -(x * (fv * rate - pmt + y * pmt)) / rate;
        }
        return pv_value;
    };
    CalculatorUgandaHomeLoanAffordability.prototype.FV = function (rate, nper, pmt, pv, type) {
        var pow = Math.pow(1 + rate, nper), fv;
        pv = pv || 0;
        type = type || 0;
        if (rate) {
            fv = (pmt * (1 + rate * type) * (1 - pow) / rate) - pv * pow;
        }
        else {
            fv = -1 * (pv + pmt * nper);
        }
        return fv;
    };
    CalculatorUgandaHomeLoanAffordability.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorUgandaHomeLoanAffordability.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorUgandaHomeLoanAffordability.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorUgandaHomeLoanAffordability;
}(Base));
export { CalculatorUgandaHomeLoanAffordability };



//////////////////
// WEBPACK FOOTER
// ./components-uganda/calculator-uganda-home-loan-affordability/calculator-uganda-home-loan-affordability.component.ts
// module id = 688
// module chunks = 0